import axios from 'axios'

// Get all transactions for admin
const getAll = async (iniDate, endDate) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/transaction/admin/${iniDate}/${endDate}`)
  return data
}

// Refund transaction
const refund = async (transaction, reason) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/signature/payment/refund/`, { transaction, reason })
  return data
}

export {
  getAll,
  refund
}
